export enum LanguageCode {
  'de' = 'de',
  'en' = 'en',
  'fr' = 'fr',
}
